import { atom } from "recoil";

import { TComp } from "MVVM/Views/Competitions/@types";

export const ActiveCampaign = atom({
  key: "ActiveCampaign_V0.1",
  default: {} as Partial<TComp>,
});
